@if (guarantee()) {
  <div class="flex w-full flex-col gap-4">
    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-4">
        <h2>{{ "appointments.headings.prescriptions" | translate }}</h2>
        <button
          class="flex items-center gap-1 font-normal text-neutral-300 underline hover:text-neutral-500"
          type="button"
          [matMenuTriggerFor]="addPrescriptionMenu"
        >
          <mat-icon>add_circle_outline</mat-icon>
          Додати призначення
        </button>
        <button
          class="flex items-center gap-1 font-normal text-neutral-300 underline hover:text-neutral-500"
          type="button"
          (click)="checkAllSimilar()"
        >
          <mat-icon>chronic</mat-icon>
          {{ "prescription.action.checkSimilarPrescriptions" | translate }}
        </button>
      </div>

      @if (canProcess()) {
        <div class="flex items-center gap-3">
          @if (hasUnprocessedPrescriptions()) {
            <p class="text-xs text-error-500">Опрацюйте всі призначення</p>
          }
          <button
            class="btn btn-primary py-2 text-sm font-thin"
            type="button"
            [disabled]="hasUnprocessedPrescriptions()"
            (click)="processGuarantee()"
          >
            Опрацювати
          </button>
        </div>
      }
    </div>

    @if (loading()) {
      <div class="flex justify-center py-8">
        <shared-spin-loading [size]="24"></shared-spin-loading>
      </div>
    } @else if (prescriptions().length > 0) {
      <div class="flex flex-col gap-2">
        @for (prescription of prescriptions(); track prescription.id) {
          <prescriptions-item
            [memberId]="memberId()"
            [prescription]="prescription"
            [allPrescriptions]="prescriptions()"
            [checkSimilarSignal]="similarCheckTrigger()"
            [guaranteeAwaitingProcessing]="canProcess()"
            (prescriptionUpdated)="refresh($event)"
          ></prescriptions-item>
        }
      </div>
    } @else {
      <div class="flex items-center justify-center rounded-2xl border-2 border-dashed border-neutral-200 py-10 text-neutral-300">
        <h4>Немає призначень</h4>
      </div>
    }
  </div>

  <mat-menu #addPrescriptionMenu="matMenu">
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addPrescription(prescriptionTypes.Drugs)"
    >
      <span class="flex items-center gap-1">
        <img
          alt="Medicines icon"
          width="20"
          height="20"
          [ngSrc]="'assets/icons/ic_pill.svg'"
        />
        {{ "medicalServices.prescriptionTypes." + prescriptionTypes.Drugs | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addPrescription(prescriptionTypes.PersonalDoctorAppointment)"
    >
      <span class="flex flex-nowrap items-center gap-1">
        <img
          alt="Doctor Appointment icon"
          width="20"
          height="20"
          [ngSrc]="'assets/icons/ic_doctor.svg'"
        />
        {{ "medicalServices.prescriptionTypes." + prescriptionTypes.PersonalDoctorAppointment | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addPrescription(prescriptionTypes.RelatedSpecialists)"
    >
      <span class="flex flex-nowrap items-center gap-1">
        <img
          alt="Doctor Appointment icon"
          width="20"
          height="20"
          [ngSrc]="'assets/icons/ic_doctor.svg'"
        />
        {{ "medicalServices.prescriptionTypes." + prescriptionTypes.RelatedSpecialists | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addPrescription(prescriptionTypes.LaboratoryService)"
    >
      <span class="flex items-center gap-1">
        <img
          alt="Laboratory Service icon"
          width="20"
          height="20"
          [ngSrc]="'assets/icons/ic_laboratory.svg'"
        />
        {{ "medicalServices.prescriptionTypes." + prescriptionTypes.LaboratoryService | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addPrescription(prescriptionTypes.InstrumentalDiagnostic)"
    >
      <span class="flex flex-nowrap items-center gap-1">
        <img
          alt="Instrumental Diagnostics icon"
          width="20"
          height="20"
          [ngSrc]="'assets/icons/ic_diagnostics.svg'"
        />
        {{ "medicalServices.prescriptionTypes." + prescriptionTypes.InstrumentalDiagnostic | translate }}
      </span>
    </button>
    <button
      mat-menu-item
      [type]="'button'"
      (click)="addFreeFormPrescription()"
    >
      <span class="flex flex-nowrap items-center gap-1">
        <mat-icon class="mr-0 h-5 w-5 text-xl text-neutral-500">edit_note</mat-icon>
        {{ "prescription.label.freeForm" | translate }}
      </span>
    </button>
  </mat-menu>
}
